import { TweenLite, Power2 } from 'gsap';
import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

export const Animation: React.FC<{ animationKey: any; onlyFade?: boolean; timeout?: number }> = ({
  animationKey,
  children,
  onlyFade = false,
  timeout = 400,
}) => {
  return (
    <TransitionGroup>
      <CSSTransition
        key={animationKey}
        mountOnEnter
        unmountOnExit
        timeout={timeout}
        in
        onEntering={(node: any) => {
          TweenLite.fromTo(
            node,
            0.6,
            {
              opacity: 0,
            },
            {
              opacity: 1,
              ease: Power2.easeOut,
            },
          ).delay(0.4);
        }}
        onExiting={
          onlyFade
            ? (node: any) => {
                TweenLite.to(node, 0.6, {
                  opacity: 0,
                });
              }
            : (node: any) => {
                node.style.position = 'absolute';
                node.style.top = 0;
                node.style.left = 0;
                TweenLite.to(node, 0.6, {
                  opacity: 0,
                });
              }
        }
      >
        {children}
      </CSSTransition>
    </TransitionGroup>
  );
};
